import { render, staticRenderFns } from "./tbmWorkerHealthStatus.vue?vue&type=template&id=4807495a"
import script from "./tbmWorkerHealthStatus.vue?vue&type=script&lang=js"
export * from "./tbmWorkerHealthStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4807495a')) {
      api.createRecord('4807495a', component.options)
    } else {
      api.reload('4807495a', component.options)
    }
    module.hot.accept("./tbmWorkerHealthStatus.vue?vue&type=template&id=4807495a", function () {
      api.rerender('4807495a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmWorkerHealthStatus.vue"
export default component.exports